import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { ZoomComponent } from './zoom.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AutoSearchModule } from '../autosearch';
import { SelectModule } from '../select';
import { PipeModule } from '../pipes';
import { ModalModule } from '../modal';
import { MeetingTypePipe } from './zoom.pipe';

registerLocaleData(localeFr);

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    SelectModule,
    PipeModule,
    NgbModule,
    ModalModule,
    AutoSearchModule,
    ],
  declarations: [
    ZoomComponent,
    MeetingTypePipe
  ],
  exports: [
    ZoomComponent,
    MeetingTypePipe
  ]
})

export class ZoomModule { }
